import { Button } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { Icon, SelectionComponentMap } from 'app/blocks/icons/list'

export interface IAttributes {
  useCompact?: boolean
  fullWidth?: boolean
  url?: string
  text: string
  type?: 'primary' | 'secondary'
  color: string
  hoverBackgroundColor?: string
  icon: Icon
  openInNewWindow?: boolean
  className?: string
}

const open = (url?: string, openInNewWindow?: boolean) => {
  if (url && (openInNewWindow === true || openInNewWindow === undefined)) {
    window.open(url)
  } else if (url && openInNewWindow === false) {
    window.location.href = url
  }
}

const ButtonBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <Button
      className={attributes.className}
      type={attributes?.type || 'primary'}
      useCompact={attributes.useCompact}
      onClick={() => open(attributes.url, attributes.openInNewWindow)}
      fullWidth={attributes.fullWidth}
      color={attributes.color}
      hoverBackgroundColor={attributes.hoverBackgroundColor}
      icon={SelectionComponentMap[attributes.icon]}
    >
      {attributes.text}
    </Button>
  )
}

export default ButtonBlock
